<ng-container *ngIf="withTooltip === true; else bare">
    <button
        class="coaching-button row with-tooltip"
        (click)="$event.stopPropagation(); setMetric()"
        [ngClass]="
            (activeMetric | async).metricId === opportunity.metricId
                ? 'active'
                : ''
        "
        hoverTooltip
        [hoverTooltipContent]="oatooltip"
        [appendToBody]="true"
        [hoverTooltipData]="opportunity"
    >
        <span class="metric-scores">
            <!---- Replace -->
            <goal-score [opportunity]="opportunity"></goal-score>
            <!---- // Replace -->

            <ng-container
                *ngIf="opportunity.percentToTarget != null; else noTarget"
            >
                <span
                    class="target-score"
                    [style.color]="opportunity.targetThresholdColour"
                >
                    <span class="score-value">{{
                        opportunity.percentToTarget >= 999
                            ? '999+'
                            : (opportunity.percentToTarget
                              | cmpsNumberWithSuffix: '1.0-0')
                    }}</span>
                    <span
                        *ngIf="opportunity.percentToTarget != null"
                        class="score-percentage"
                        >%</span
                    >
                </span>
            </ng-container>
            <ng-template #noTarget>
                <span class="target-score">
                    <span class="score-value none">{{
                        i18n._842_N_A | translate
                    }}</span>
                </span>
            </ng-template>
        </span>
        <span class="metric-description col">{{
            opportunity?.metric?.metricShortName
        }}</span>
    </button>
</ng-container>

<ng-template #bare>
    <button
        class="coaching-button row bare"
        (click)="disableClick ? '' : setMetric()"
        [ngClass]="
            (activeMetric | async).metricId === opportunity.metricId
                ? 'active'
                : ''
        "
    >
        <span class="metric-scores">
            <goal-score [opportunity]="opportunity"></goal-score>

            <ng-container
                *ngIf="opportunity.percentToTarget != null; else noTarget"
            >
                <span
                    class="target-score"
                    [style.color]="opportunity.targetThresholdColour"
                >
                    <span class="score-value">{{
                        opportunity.percentToTarget >= 999
                            ? '999+'
                            : (opportunity.percentToTarget
                              | cmpsNumberWithSuffix: '1.0-0')
                    }}</span>
                    <span
                        *ngIf="opportunity.percentToTarget != null"
                        class="score-percentage"
                        >%</span
                    >
                </span>
            </ng-container>
            <ng-template #noTarget>
                <span class="target-score">
                    <span class="score-value none">{{
                        i18n._842_N_A | translate
                    }}</span>
                </span>
            </ng-template>
        </span>
        <span class="metric-description col">{{
            opportunity?.metric?.metricShortName
        }}</span>
    </button>
</ng-template>

<ng-template
    #oatooltip
    let-data="opportunity"
>
    <div class="custom-tooltip oatooltip opportunity-hover">
        <div class="metric-mini-view">
            <table>
                <tr class="metric-view-divider">
                    <th>{{ i18n._7339_METRIC_NAME | translate }}</th>
                    <td>{{ opportunity.metric.metricName }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <th>{{ i18n._7340_METRIC_ID | translate }}</th>
                    <td>{{ opportunity.metricId }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <th>{{ i18n._4106_CURRENT_ACTUAL | translate }}</th>
                    <td
                        *ngIf="opportunity.actual != null; else noTarget1"
                        [style.color]="opportunity.targetThresholdColour"
                    >
                        {{ opportunity.actual | number: '1.0-2' }}
                    </td>
                    <ng-template #noTarget1>
                        <td>{{ i18n._852_NO_DATA | translate }}</td>
                    </ng-template>
                </tr>
                <tr class="metric-view-divider">
                    <th>{{ i18n._768___TO_TARGET | translate }}</th>
                    <td
                        *ngIf="
                            opportunity.actual != null &&
                                opportunity.percentToTarget != null;
                            else noTarget2
                        "
                        [style.color]="opportunity.targetThresholdColour"
                    >
                        {{ opportunity.percentToTarget | number: '1.0-2' }}
                    </td>
                    <ng-template #noTarget2>
                        <td>{{ i18n._852_NO_DATA | translate }}</td>
                    </ng-template>
                </tr>
                <tr
                    class="metric-view-divider"
                    *ngIf="opportunity.oaAging && opportunity.oaThresholdValue"
                >
                    <th>
                        {{ i18n._7341_DAYS_AGING_AS_OPPORTUNITY | translate }}
                    </th>
                    <td>{{ opportunity.oaAging }}</td>
                </tr>
                <tr
                    class="metric-view-divider"
                    *ngIf="opportunity.coachingType !== CoachingType.NON_OA"
                >
                    <th>{{ i18n._7503_OPPORTUNITY_STATUS | translate }}</th>
                    <td>
                        {{
                            opportunity.oppStatusName
                                ? opportunity.oppStatusName
                                : (i18n._842_N_A | translate)
                        }}
                    </td>
                </tr>
                <tr
                    *ngIf="opportunity.oppStatus === OpportunityStatus.CLOSED"
                    class="metric-view-divider"
                >
                    <th>{{ i18n._7332_DISPOSITION | translate }}</th>
                    <td>{{ opportunity.disposition }}</td>
                </tr>

                <ng-container
                    *ngIf="
                        opportunity.coachingType !== CoachingType.NON_OA &&
                        opportunity.oppStatus !== OpportunityStatus.CLOSED
                    "
                >
                    <tr class="metric-view-divider">
                        <th>
                            {{ i18n._7504_INTERVENTION_DAYS_USED | translate }}
                        </th>
                        <td>{{ opportunity.daysInIntervention || '0' }}</td>
                    </tr>
                    <tr class="metric-view-divider">
                        <th>
                            {{ i18n._7505_INTERVENTION_DAYS_LEFT | translate }}
                        </th>
                        <td>{{ opportunity.interventionRemaining || '0' }}</td>
                    </tr>
                    <tr class="metric-view-divider">
                        <th>
                            {{ i18n._7506_PERCENT_TO_INTERVENTION | translate }}
                        </th>
                        <td>
                            {{
                                opportunity.percentToIntervention !== null
                                    ? opportunity.percentToIntervention + '%'
                                    : '-'
                            }}
                        </td>
                    </tr>
                </ng-container>

                <tr
                    *ngIf="opportunity.oppStatus === OpportunityStatus.ACTIVE"
                    class="metric-view-divider"
                >
                    <th>{{ i18n._7507_OPEN_DAYS | translate }}</th>
                    <td>{{ opportunity.openDays }} days</td>
                </tr>

                <ng-container
                    *ngIf="
                        opportunity.coachingType === CoachingType.COACHED ||
                        opportunity.goalStatusId === _GoalStatus.PRE_APPROVAL ||
                        opportunity.goalStatusId === _GoalStatus.UPDATING ||
                        opportunity.goalStatusId === _GoalStatus.ACTIVE
                    "
                >
                    <tr class="metric-view-divider">
                        <th>{{ i18n._7367___TO_GOAL | translate }}</th>
                        <td>
                            <!--goalStatusLabel would already be set to no-data already when percentToGoal == null-->
                            <span *ngIf="!opportunity.goalStatusLabel">
                                {{
                                    opportunity.percentToGoal | number: '1.0-2'
                                }}
                            </span>
                            <span *ngIf="opportunity.goalStatusLabel">
                                {{ opportunity.goalStatusLabel | translate }}
                            </span>
                        </td>
                    </tr>
                    <tr
                        class="metric-view-divider"
                        *ngIf="
                            opportunity.coachedComponents &&
                            opportunity.coachedComponents.length
                        "
                    >
                        <th>{{ i18n._7342_COMPONENT_NAME | translate }}</th>
                        <td class="metric-hover-component-list">
                            <ng-container
                                *ngFor="
                                    let c of opportunity.coachedComponents;
                                    let i = index
                                "
                            >
                                <span
                                    class="d-block p-0 component-view-divider"
                                    >{{ c.metric.metricName }}</span
                                >
                            </ng-container>
                        </td>
                    </tr>
                </ng-container>
                <tr
                    class="metric-view-divider"
                    *ngIf="
                        opportunity.coachingType === CoachingType.COACHED ||
                        opportunity.coachingType === CoachingType.NON_OA
                    "
                >
                    <ng-container
                        *ngIf="opportunity.goalStatusId === _GoalStatus.CLOSED"
                    >
                        <th>{{ i18n._7331_CLOSED_ON | translate }}</th>
                        <td>
                            {{ opportunity.goalEndDate | cmpsDate: 'MMM d, y' }}
                        </td>
                    </ng-container>
                    <ng-container
                        *ngIf="opportunity.goalStatusId != _GoalStatus.CLOSED"
                    >
                        <th>
                            {{ i18n._9824_EXP__ACHIEVEMENT_DATE | translate }}
                        </th>
                        <td *ngIf="!opportunity.estCompletionForGoal">
                            {{ i18n._842_N_A | translate }}
                        </td>
                        <td
                            [class.bar-hover-tooltip--expired]="
                                opportunity.goalExpired
                            "
                            *ngIf="opportunity.estCompletionForGoal"
                        >
                            {{
                                !opportunity.goalExpired
                                    ? (opportunity.estCompletionForGoal
                                      | cmpsDate: 'MMM d, y')
                                    : (i18n._9809_MISSED | translate)
                            }}
                        </td>
                    </ng-container>
                </tr>
                <tr
                    class="metric-view-divider"
                    *ngIf="
                        opportunity.coachingType === CoachingType.COACHED ||
                        (opportunity.coachingType === CoachingType.UNCOACHED &&
                            opportunity?.commitmentStrings?.length) ||
                        opportunity.coachingType === CoachingType.NON_OA
                    "
                >
                    <th>{{ i18n._7346_COMMITMENT_NAME | translate }}</th>
                    <td class="metric-hover-component-list">
                        <ng-container
                            *ngFor="let c of opportunity.commitmentStrings"
                        >
                            <span class="d-block p-0 component-view-divider">
                                {{ c }}
                            </span>
                        </ng-container>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>
